import { t } from "i18next";
import { useNavigate } from "react-router";

import { routeEnum } from "@enums/route.enum";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="container my-5 text-center">
      <h4 className="my-3">{t("404")}</h4>

      <button
        className="btn fg-btn fg-btn-small fg-btn-my-reg active"
        onClick={() => navigate(routeEnum.Home)}
      >
        {t("goHome")}
      </button>
    </div>
  );
};

export default NotFound;
